import React, { useState } from 'react';
import 'react-image-lightbox/style.css';
import Lightbox from 'react-image-lightbox';
import "./newsevent.css";


import WSDimg1 from '../../assets/wsdimg1.jpg';
import WSDimg2 from '../../assets/wsdimg2.jpg';
import WSDimg3 from '../../assets/wsdimg3.jpg';
import WSDimg4 from '../../assets/wsdimg4.jpg';
import WSDimg5 from '../../assets/wsdimg5.jpg';
import WSDimg6 from '../../assets/wsdimg6.jpg';
import WSDimg7 from '../../assets/wsdimg7.jpg';
import WSDimg8 from '../../assets/wsdimg8.jpg';
import WSDimg9 from '../../assets/wsdimg9.jpg';
import WSDimg10 from '../../assets/wsdimg10.jpg';
import WSDimg11 from '../../assets/wsdimg11.jpg';
import WSDimg12 from '../../assets/wsdimg12.jpg';
import WSDimg13 from '../../assets/wsdimg13.jpg';
import WSDimg14 from '../../assets/wsdimg14.jpg';
import WSDimg15 from '../../assets/wsdimg15.jpg';
import WSDimg16 from '../../assets/wsdimg16.jpg';
import WSDimg17 from '../../assets/wsdimg17.jpg';
import WSDimg18 from '../../assets/wsdimg18.jpg';




const sections = [
  {
   
    images: [WSDimg1, WSDimg2, WSDimg3, WSDimg4, WSDimg5, WSDimg6, WSDimg7, WSDimg8, WSDimg9, WSDimg10, WSDimg11, WSDimg12 , WSDimg13, WSDimg14, WSDimg15, WSDimg16 , WSDimg17 , WSDimg18],
  },
];

const WorldSightDay = () => {
  const [isViewerOpen, setIsViewerOpen] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);
  const [currentImages, setCurrentImages] = useState([]);

  const openViewer = (images, index) => {
    setCurrentImages(images);
    setPhotoIndex(index);
    setIsViewerOpen(true);
  };

  const closeViewer = () => {
    setIsViewerOpen(false);
  };

  return (
    <div className="gallery">
      <h1 align="center">World Sight Day - 2024</h1>
      <p className="intro-second-sight">World Sight Day 2024, celebrated by the Eye Care Institute, 
        focused on raising awareness about the importance of eye health and preventing avoidable blindness.</p>
      <br />
      {sections.map((section, sectionIndex) => (
        <div key={sectionIndex} className="gallery-section">
          <div className="gallery-header">
            <h2>{section.title}</h2>
          </div>
          <div className="gallery-grid">
            {section.images.map((src, index) => (
              <div key={index} className="gallery-item">
                <div className="overlay-container">
                <img
                    src={src}
                    alt={`Gallery item ${index + 1} in ${section.title}`} // Avoid the word "image"
                    className="gallery-image"
                    onClick={() => openViewer(section.images, index)}
                  />

                  <div className="overlay">
                    <button
                      className="max-view-button"
                      onClick={() => openViewer(section.images, index)}
                    >
                      <span>&#x2922;</span> {/* Fullscreen icon */}
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}

      {isViewerOpen && (
        <Lightbox
          mainSrc={currentImages[photoIndex]}
          nextSrc={currentImages[(photoIndex + 1) % currentImages.length]}
          prevSrc={
            currentImages[
              (photoIndex + currentImages.length - 1) % currentImages.length
            ]
          }
          onCloseRequest={closeViewer}
          onMovePrevRequest={() =>
            setPhotoIndex(
              (photoIndex + currentImages.length - 1) % currentImages.length
            )
          }
          onMoveNextRequest={() =>
            setPhotoIndex((photoIndex + 1) % currentImages.length)
          }
        />
      )}
    </div>
  );
};
export default WorldSightDay